// @flow
import parseUnit from "parse-unit";
export var unit = function unit(value) {
  return parseUnit(value)[1];
};
export var unitless = function unitless(value) {
  return parseUnit(value)[0];
};